import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  TextField,
} from "@mui/material";

import CarrierDialogStandardActions from "./CarrierDialogStandardActions";

export default function CarrierTeamMemberDialogs({ vm }) {
  const {
    handleCloseEditDialog,
    handleCloseDialog,
    setTeamMemberPhone,
    setTeamMemberEmail,
    setTeamMemberPriority,
    setTeamMemberPosition,
    setTeamMemberStatus,
    setTeamMemberName,
    teamMemberPriority,
    teamMemberPosition,
    selectedMember,
    teamMemberPhone,
    setSelectedMember,
    teamMemberEmail,
    teamMemberStatus,
    teamMemberName,
    priorities,
    handleUpdateMember,
    handleInvite,
    positions,
    isSubmitting,
    sendInvite,
    statuses,
    setSendInvite,
    openEditDialog,
    open,
  } = vm;

  return (
    <>
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>Add New Team Member</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={teamMemberName}
            onChange={(e) => setTeamMemberName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={teamMemberEmail}
            onChange={(e) => setTeamMemberEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Phone Number"
            type="text"
            fullWidth
            variant="outlined"
            value={teamMemberPhone}
            onChange={(e) => setTeamMemberPhone(e.target.value)}
          />
          <TextField
            select
            margin="dense"
            label="Position"
            fullWidth
            variant="outlined"
            value={teamMemberPosition}
            onChange={(e) => setTeamMemberPosition(e.target.value)}
          >
            {positions.map((position) => (
              <MenuItem key={position} value={position}>
                {position}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Status"
            fullWidth
            variant="outlined"
            value={teamMemberStatus}
            onChange={(e) => setTeamMemberStatus(e.target.value)}
          >
            {statuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Priority"
            fullWidth
            variant="outlined"
            value={teamMemberPriority}
            onChange={(e) => setTeamMemberPriority(e.target.value)}
          >
            {priorities.map((priority) => (
              <MenuItem key={priority} value={priority}>
                {priority}
              </MenuItem>
            ))}
          </TextField>
          <FormControlLabel
            control={
              <Checkbox
                checked={sendInvite}
                onChange={(e) => setSendInvite(e.target.checked)}
              />
            }
            label="Send Invite Email"
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <CarrierDialogStandardActions
          onCancel={handleCloseDialog}
          onSubmit={handleInvite}
          submitting={isSubmitting}
          submitLabel="Add Team Member"
        />
      </Dialog>

      <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
        <DialogTitle>Edit Team Member</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_name || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_name: e.target.value }))
            }
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_email || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_email: e.target.value }))
            }
          />
          <TextField
            margin="dense"
            label="Phone Number"
            type="text"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_phonenumber || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_phonenumber: e.target.value }))
            }
          />
          <TextField
            select
            margin="dense"
            label="Position"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_position || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_position: e.target.value }))
            }
          >
            {positions.map((position) => (
              <MenuItem key={position} value={position}>
                {position}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Status"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_status ? "Available" : "Unavailable"}
            onChange={(e) =>
              setSelectedMember((prev) => ({
                ...prev,
                team_member_status: e.target.value === "Available",
              }))
            }
          >
            {statuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            margin="dense"
            label="Priority"
            fullWidth
            variant="outlined"
            value={selectedMember?.team_member_priority || ""}
            onChange={(e) =>
              setSelectedMember((prev) => ({ ...prev, team_member_priority: e.target.value }))
            }
          >
            {priorities.map((priority) => (
              <MenuItem key={priority} value={priority}>
                {priority}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleUpdateMember}
            color="primary"
            variant="contained"
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

CarrierTeamMemberDialogs.propTypes = {
  vm: PropTypes.object.isRequired,
};
